
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      element: null,
      isSVG: false,
      imgSrc: null,
      imgWidth: null,
      imgHeight: null,
      imgAlt: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setImgAttr()
      this.handleStoryblokAsset()
    })
  },
  methods: {
    setImgAttr() {
      this.imgSrc = this.src || this.blok?.src?.filename
      this.imgAlt = this.alt || this.blok?.src?.alt
      this.imgWidth = this.width || this.blok?.width
      this.imgHeight = this.height || this.blok?.height
    },
    async handleStoryblokAsset() {
      const isSvg = this.imgSrc?.includes('svg')

      if (this.imgSrc && isSvg) {
        this.isSVG = true

        // fetch svg raw html
        const rawHTML = await this.useFetchAsset(this.imgSrc)

        // this.mergeAttr()

        this.element = rawHTML
      } else {
        this.isSVG = false
      }
    },
    async useFetchAsset(url) {
      return await this.$axios
        .get(this.buildUrl(url))
        .then((res) => res.data)
        .catch((err) => console.warn(err))
    },
    buildUrl(url = '') {
      if (!url) return
      const protocol = 'https://'
      const [, domain] = url.split('https://')

      return protocol + 's3.amazonaws.com/' + domain
    },
    // mergeAttr(rawHTML) {
    //   // split raw html svg tag
    //   const splitHtmlFirst = rawHTML.substring(0, 4)
    //   const splitHtmlSecond = rawHTML.slice(4)

    //   // build attributes string
    //   const mergeAttrs = ` style="width: ${this.imgWidth}; height: ${this.imgHeight}"`
    //   console.log([splitHtmlFirst, mergeAttrs, splitHtmlSecond].join(''))
    //   return [splitHtmlFirst, mergeAttrs, splitHtmlSecond].join('')
    // },
  },
}
